<ul class="navbar-nav ms-auto d-md-flex align-items-center">
  <ng-container *ngIf="(isAuthenticated$ | async) === false; else signin">
    <li class="nav-item dropdown">
      <button
        class="btn btn-primary common-btn-secondary dropdown-toggle"
        id="signInDropdown"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ logininfo.signin }}
        <img
          src="assets/images/down-arrow.svg"
          alt="Toggle dropdown"
          class="sign-in-dropdown-arrow"
        />
      </button>
      <div
        class="dropdown-menu dropdown-menu-end sign-in-menu"
        aria-labelledby="signInDropdown"
      >
        <div class="sign-in-header">
          <h6 class="mb-4 pb-3 registration-heading">{{logininfo.haveAnAccount}}</h6>
          <button
            class="common-btn-secondary btn mb-4 pb-3"
            type="button"
            (click)="loginUser()"
          >
            {{logininfo.userSignIn}}
          </button>
        </div>

        <hr class="my-3" />

        <div class="mb-4 pb-3 mt-4 pt-2">
          <div class="registration-heading mt-3 mb-4">{{logininfo.wbdCorporateUsers}}</div>
          <p class="mb-4 registration-sub-heading">
            {{logininfo.wbPara}}
          </p>
          <a
            class="text-link"
            href="javascript:void(0)"
            (click)="navigateToRegister()"
          >
            {{logininfo.register}}
          </a>
        </div>

        <hr class="my-3" />

        <div class="mb-4 pb-2">
          <p class="mt-4 pt-3 mb-0 registration-sub-heading">
            {{logininfo.notAEmployee}}
          </p>
          <a class="text-link mail-link" href="mailto:OpsClientServices@wbd.com">
            {{logininfo.opsEmail}}
          </a>
        </div>

        <button
          class="btn btn-link w-100 text-center sign-in-close mb-0"
          type="button"
          data-bs-toggle="dropdown"
        >
          {{logininfo.close}}
      </button>
      </div>
    </li>
  </ng-container>
</ul>
<ul class="navbar-nav d-none d-md-flex">
  <ng-template #signin>
    <li class="nav-item dropdown">
      <a class="nav-link nav-client-resource user-name" id="profileDropdown" role="button"
        data-bs-toggle="dropdown" aria-expanded="false">
        <span class="user-name-logged">{{name}}</span><span class="span-image-wrapper"><img class="user-img"
            src="../assets/images/user-icon.svg" alt=""/></span>
        <span class="header_dropdown-multiselect__caret"></span>
      </a>
      <ul class="dropdown-menu my-profile client-res-dropdown" aria-labelledby="profileDropdown">
        <li *ngIf="permissionsData && permissionsData['manageProfile'] || userTypeId === 2" ><a class="dropdown-item" (click)="redirectToProfile()">{{logininfo.myprofile}}</a></li>
        <li><a class="dropdown-item" (click)="logout()">{{logininfo.logout}}</a></li>

      </ul>
    </li>
  </ng-template>
</ul>
